import { buildQuery } from "../lib/network";
import { coreService } from "../services/coreService";
import { FirstArgumentType, SecondArgumentType } from "../types/ArgumentTypes";

export type Department = Awaited<ReturnType<typeof coreService.departmentsList>>["data"][0];
export const getDepartments = (headers: any) => () => {
  return buildQuery(coreService.departmentsList({ headers }), (response) => {
    return response.data;
  });
};

export const getDepartment = (headers: any) => (id: number) => {
  return buildQuery(coreService.departmentsDetail(id, { headers }), (response) => {
    return response.data;
  });
};

export const createDepartment = (headers: any) => (data: FirstArgumentType<typeof coreService.departmentsCreate>) => {
  return buildQuery(coreService.departmentsCreate(data, { headers }), (response) => {
    return response.data;
  });
};

export const updateDepartment =
  (headers: any) =>
  ({ id, data }: { id: number; data: SecondArgumentType<typeof coreService.departmentsUpdate> }) => {
    return buildQuery(coreService.departmentsUpdate(id, data, { headers }), (response) => {
      return response.data;
    });
  };

export const getDepartmentPermissions = (headers: any) => (id: number) => {
  return buildQuery(coreService.departmentsPermissionsDetail(id, { headers }), (response) => {
    return response.data;
  });
};

export const updateDepartmentPermissions =
  (headers: any) =>
  ({ id, data }: { id: number; data: SecondArgumentType<typeof coreService.departmentsPermissionsUpdate> }) => {
    return buildQuery(coreService.departmentsPermissionsUpdate(id, data, { headers }), (response) => {
      return response.data;
    });
  };

export type DepartmentRejectedDeletionReason = Awaited<
  ReturnType<typeof coreService.departmentsCheckDeleteDetail>
>["data"]["errors"][number];
export const checkIfDepartmentCanBeDeleted = (headers: any) => (id: number) => {
  return buildQuery(coreService.departmentsCheckDeleteDetail(id, { headers }), (response) => {
    return response.data;
  });
};

export const deleteDepartment = (headers: any) => (id: number) => {
  return buildQuery(
    coreService.departmentsDelete(id, {
      headers: {
        ...headers,
        "Content-Type": "text/plain",
      },
    }),
    (response) => {
      return response.data;
    },
  );
};
